import { TagsCard } from '~/components/TagsCard';
import {
  useRegistrationTags,
  useRegistrationTagsUpsert,
  useStoreRegistrationTags,
} from '~/hooks/useRegistrationTags';

export function RegistrationTagDisplay({
  registrationId,
}: {
  registrationId: number;
}) {
  const { data: storeTags = [], isPending: isOptionsPending } =
    useStoreRegistrationTags();
  const { data: currentTags = [], isPending: isCurrentPending } =
    useRegistrationTags(registrationId);
  const { mutateAsync: upsertTags, isPending: isUpsertPending } =
    useRegistrationTagsUpsert(registrationId);

  return (
    <TagsCard
      storeTags={storeTags}
      currentTags={currentTags}
      isLoading={isOptionsPending || isCurrentPending}
      isSaving={isUpsertPending}
      onChange={(tagNames) => {
        upsertTags(tagNames).catch((error) => console.error(error));
      }}
    />
  );
}
